<script lang="ts">
	import Link from "./Link.svelte";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import type { Image } from "../../../core/schema/Image.js";
	import translations from "./Card.translations.json";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import { textLengthLimit } from "../../../core/utils/textLengthLimit.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import Content from "./Content.svelte";

	const translate = getTranslate(translations);

	export let toButtonText: string | undefined = undefined;
	export let customButtonText: string | undefined = undefined;
	export let title: string;
	export let description: string;
	export let descriptionIsContent = false;
	export let urlSlug: string | undefined = undefined;
	export let image: Image | string | undefined = undefined;
	export let squaredImage = true;
	export let containImage = false;
	export let loading: "eager" | "lazy" = "lazy";
</script>

<div
	class="border-border bg-ltwhiteout group flex h-full grow flex-col justify-between gap-4 overflow-hidden rounded-lg border-2 p-3 transition-[transform,box-shadow] duration-300 ease-in-out lg:max-w-[31rem] lg:gap-6"
>
	<div class="flex flex-col gap-6">
		{#if image}
			<div class="relative {squaredImage ? 'h-[17.5rem]' : 'h-[12.5rem]'} w-full shrink-0 overflow-hidden rounded-md">
				<a role={urlSlug ? "link" : "none"} href={urlSlug ? `/${urlSlug}` : undefined}>
					{#if typeof image === "string"}
						<StaticPicture
							{image}
							alt={title}
							width={0}
							height={280}
							imgClass="size-full {containImage
								? 'object-contain bg-white'
								: 'object-cover'} rounded-md inset-0 absolute {squaredImage ? 'h-[17.5rem]' : 'h-[12.5rem]'}"
							class={squaredImage ? "h-[17.5rem] " : "h-[12.5rem]"}
							{loading}
						/>
					{:else}
						<DynamicPicture
							{image}
							alt={title}
							width={0}
							height={280}
							imgClass="size-full {containImage
								? 'object-contain bg-white'
								: 'object-cover'} rounded-md inset-0 absolute {squaredImage ? 'h-[17.5rem]' : 'h-[12.5rem]'}"
							class={squaredImage ? "h-[17.5rem]" : "h-[12.5rem]"}
							{loading}
							bucket="storage"
						/>
					{/if}
				</a>
			</div>
		{/if}

		<article class="bg-ltwhiteout relative z-[1] flex flex-col gap-3 lg:gap-4">
			<a
				role={urlSlug ? "link" : "none"}
				href={urlSlug ? `/${urlSlug}` : undefined}
				class="text-ltsecondary font-bahnschrift text-2md row-span-2 m-0 line-clamp-2 p-0 font-bold"
				class:group-hover:text-ltprimary={urlSlug}
			>
				{nbspify(title)}
			</a>
			{#if descriptionIsContent}
				<Content content={description} />
			{:else}
				<div class="text-2xs row-span-6 line-clamp-3 leading-[1.6] tracking-wide">
					{textLengthLimit(nbspify(description), 250)}
				</div>
			{/if}
		</article>
	</div>
	{#if urlSlug}
		<div class="flex flex-wrap items-end justify-start">
			<Link
				asButton
				class="font-bold"
				variant="tertiary"
				icon={arrowRight}
				href="/{urlSlug}"
				aria-label={translate("linkAriaLabel", { title }, true)}
			>
				{#if toButtonText}
					{translate("to")}&nbsp;{toButtonText}
				{:else if customButtonText}
					{customButtonText}
				{:else}
					{translate("moreInfo")}
				{/if}
			</Link>
		</div>
	{/if}
</div>
